var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_c('router-link',{attrs:{"to":{ name: 'admin-design-survey' }}},[_vm._v("Design")]),_vm._v(" - Add Page")],1),_vm._v(" "),_c('vue-form-generator',{staticClass:"vue-form-generator--admin",attrs:{"schema":_vm.buildSchema('page', 'pageSchema', 'basicInfo', 'new'),"model":_vm.formModel,"options":_vm.formOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }